export enum AllFilterTypeEnum {
    None = 0,
    All = 1,
    AllWithInactive = 2,
}
